<template>
	<div class="index-pc">
		<!-- 通用头部 -->
		<!-- <m-header></m-header> -->

		<div class="swiper-container banner-mdl" id="bannerSwiper">
			<div class="swiper-wrapper">
				<div class="swiper-slide" v-for="(item,index) in bannerList" :key="item.bannerId">
					<div class="bg" :class="{hover:item.bannerUrl}" :style="`background-image:url(${item.bannerImg})`" @click="goBannerDetail(item)"></div>
				</div>
			</div>
			<div class="swiper-pagination"></div>
		</div>

		<!-- <div class="banner">
			<img v-if="bannerList[0]" class="img" :src="bannerList[0].bannerImg" alt="">
		</div> -->

		<!-- 登录入口按钮 -->
		<!-- <div class="login-enter w1200">
			<ul class="list">
				<li v-for="(item,index) in loginList" :key="item.orgPlatformId" :class="'ico'+(index+1)"
					@click.prevent="goUrl(`${item.platformUrl}/#/login?systemType=${item.platformCode}`,'outNew')">
					<a href="javascript:;">{{item.platformName}}</a>
				</li>
			</ul>
		</div> -->

		<!-- mdl01-新闻动态、政策文件 -->
		<div class="mdl01">
			<div class="w1200 mdl01-ctn">
				<div class="mdl01-left">
					<div class="left-img" v-if="newsList[newsTagIndex] && newsList[newsTagIndex].contentCover">
						<img :src="newsList[newsTagIndex].contentCover" alt="">
					</div>

					<div class="news-box">
						<div class="mdl01-tag">
							<span :class="{act:index==newsTagIndex}" v-for="(item,index) in newsList" :key="item.columnId"
								@click="changeNews(index)">{{item.columnName}}</span>
							<!-- <a class="more" href="javascript:;" @click="goUrl({ name:'news',params:{ id:newsParentId }	})">查看更多</a> -->
						</div>
						<div class="news-list" v-for="(item,index) in newsList" :key="item.columnId" v-show="index==newsTagIndex">
							<ul>
								<li v-for="(item2,index2) in item.childrenList" :key="item2.contentId"
									@click="goNewsDetail(item2.contentId,item2.columnId)">
									<h4 class="text-elli">{{item2.contentTitle}}</h4>
									<div class="date">{{item2.createdDt.substring(0,10)}}</div>
								</li>
							</ul>
						</div>
					</div>
				</div>

				<div class="mdl01-right">
					<ul class="login-btns">
						<li v-for="(item,index) in loginList" :key="item.orgPlatformId" :class="'ico'+(index+1)"
							@click="goUrl(`${item.platformUrl}/#/login?systemType=${item.platformCode}`,'outNew')">
							{{item.platformName}}
						</li>
					</ul>
				</div>
			</div>
		</div>

		<!-- mdl02-好课推荐 -->
		<div class="mdl02">
			<div class="w1200">
				<div class="index-head">
					<div class="title">
						<h2>好课推荐</h2>
					</div>
				</div>
				<div class="mdl02-ctn">
					<ul class="course-list">
						<li v-for="(item,index) in courseList" :key="item.courseId" @click="goCourseDetail(item)" >
							<div v-if="item.courseLevelName" class="label" :class="item.courseLevelClass">{{item.courseLevelName}}</div>
							<!-- <img v-if="item.labelImage" class="label" :src="$img(item.labelImage)" alt=""> -->
							<img class="img" :src="item.courseImg || dfImg" alt="">
							<div class="info">
								<div class="top">
									<h3 :title="item.courseName">{{item.courseName}}</h3>
								</div>
								<p>{{item.orgName}} | {{item.teacherName}}</p>
							</div>
							<div class="btm">
								<span class="term" :class="{gray:item.offerCoursesStu==3}"
									v-if="item.termName && item.offerCoursesStu!=4">{{item.termName}}</span>
								<span class="status" :class="item.offerCoursesClass">{{item.offerCoursesName}}</span>
								<span class="learn-num">{{item.allChooseCount || 0}}</span>
							</div>
						</li>
					</ul>
					<a href="javascript:;" class="more" @click="goUrl('/course')">查看更多</a>
				</div>
			</div>
		</div>

		<!-- mdl03-联盟院校 -->
		<div class="mdl03">
			<div class="w1200">
				<div class="index-head">
					<div class="title">
						<h2>合作院校</h2>
						<!-- <span>LEAGUE COLLEGES</span> -->
					</div>
				</div>
				<div class="mdl03-ctn" v-if="collegesData">
					<div class="category-item">
						<ul class="school-list clearfix">
							<li v-for="(item,index) in collegesData" :key="index" @click="goCollegesDetail(item)">
								<div class="logo" :style="'background-image:url('+ (item.orgLogo || dfImg) +')'"></div>
								<h4>{{item.orgName}}</h4>
								<h5>{{item.orgEnName}}</h5>
								<div class="btm">
									<div class="btm-item">
										<div class="num"><span>{{item.courseCounts}}</span>门</div>
										<div class="text">课程</div>
									</div>
									<div class="btm-item">
										<div class="num"><span>{{item.teacherCounts}}</span>名</div>
										<div class="text">教师</div>
									</div>
								</div>
								<!-- <p>{{item.courseCounts}}门课程  |  {{item.teacherCounts}}名教师</p> -->
							</li>
						</ul>
					</div>
					<a href="javascript:;" class="more" @click="goUrl('/colleges')">查看更多院校</a>
				</div>
			</div>
		</div>

		<!-- 通用底部 -->
		<!-- <m-footer></m-footer> -->
	</div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
export default {
	data () {
		return {
			bannerList:[],	//广告列表
			courseList:[],	//课程列表

			newsList:[],	//新闻列表
			newsTagIndex:0,
			collegesData:null,	//院校
			newsParentId:'',	//新闻详情父级id
			loginList:[],		//几个登录入口信息
		}
	},

	async created(){
		await this.$onLaunched;		//监听加载了APP.vue中的onLaunched的异步后执行
		this.getBanner()
		this.getCourseList()
		this.getColleges()
		this.getLoginEnter()
		this.getFirstColumnList()

	},

	// computed:{
	// 	navList(){
	// 		return this.$store.state.navList
	// 	}
	// },

	// watch:{
	// 	navList(val){
	// 		if(val){
	// 			this.getFirstColumnList()
	// 		}
	// 	}
	// },


	methods:{
		//查询门户首页轮播图
		getBanner(){
			this.$axios({
				url:`/jxedu/api/site/slideshowList/1`,
				// params:{
				// 	bannerType:1
				// }
			}).then(res=>{
				let list = res.data
				this.bannerList = list
				setTimeout(()=>{
					this.loadSwiper()
				},500)
			})
		},

		//切换新闻动态
		changeNews(index){
			this.newsTagIndex = index
		},

		//查询一级栏目
		getFirstColumnList(){
			const { navList } = this.$store.state
			let parentId = ''
			navList.forEach(item=>{
				if(item.columnCode == 100202){
					parentId = item.columnId
				}
			})
			this.newsParentId = parentId
			this.$axios({
				url:`/jxedu/api/site/secondColumnList/${parentId}`,
			}).then(res=>{
				let list = res.data
				list.forEach((item,index)=>{
					item.contentCover = ''
					item.childrenList = []
					this.getNewList(item.columnId,index).then(result=>{
						item.contentCover = result.contentCover
						item.childrenList = result.list
					})
				})
				this.newsList = list
				// list.forEach((item,index)=>{
				// 	this.getNewList(item.columnId,index)
				// })
			})
		},

		//查询门户首页二级栏目数据
		getNewList(columnId,index){
			return new Promise((resolve, reject) => {
				this.$axios({
					url:`/jxedu/api/site/columnContents`,
					params:{
						columnId,
						pageNum:1,
						pageSize:4
					}
				}).then(res=>{
					let list = res.data.rows
					let contentCover = 'http://jx-edu.oss-cn-shenzhen.aliyuncs.com/datafile/public/20220514dfcb94c36aae4712892df13e222bf126.png'
					list.forEach(item2=>{
						if(!contentCover){	//随机获取一张封面图
							contentCover = item2.contentCover
						}
						item2.contentDesc = this.$common.removeHTMLTag(item2.contentDesc)
						item2.updateYear = item2.createdDt.substring(0,4)
						item2.updateMonthDay = item2.createdDt.substring(5,7) + '.' + item2.createdDt.substring(8,10)
					})
					resolve({list,contentCover})
				})
			})
		},

		//查询教学计划课程数据列表
		getCourseList(){
			this.$axios({
				url:`/jxedu/api/site/teachPlanList`,
				params:{
					pageNum:1,
					pageSize:8
				}
			}).then(res=>{
				let list = res.rows
				list.forEach(item=>{
					switch(item.courseLevel){	//课程级别：0普通网课 1联盟精品课 2国家精品课 3省级精品课
						case 0: item.courseLevelName = ''; item.courseLevelClass = ''; break;
						case 1: item.courseLevelName = '省级精品'; item.courseLevelClass = 'label1'; break;
						case 2: item.courseLevelName = '国家精品'; item.courseLevelClass = 'label2'; break;
						case 3: item.courseLevelName = '省级线上一流'; item.courseLevelClass = 'label3'; break;
						case 4: item.courseLevelName = '国家线上一流'; item.courseLevelClass = 'label4'; break;
					}
					switch(item.offerCoursesStu){	//开课状态：0:全部，1:即将开课,2:开课中,3:已结课,4:暂未开课
						case 1: item.offerCoursesName = '即将开课'; item.offerCoursesClass = 'orange'; break;
						case 2: item.offerCoursesName = '开课中'; item.offerCoursesClass = 'blue'; break;
						case 3: item.offerCoursesName = '已结课'; item.offerCoursesClass = 'gray'; break;
						case 4: item.offerCoursesName = '暂未开课'; item.offerCoursesClass = 'gray'; break;
					}
				})
				this.courseList = list
			})
		},


		//查询院校数据
		getColleges(){
			this.$axios({
				url:`/jxedu/api/site/findSiteOrg`,
			}).then(res=>{
				let data = res.data
				this.collegesData = data
			})
		},

		//加载幻灯片
		loadSwiper(){
			var _this = this
			this.mySwiper = new Swiper ('#bannerSwiper', {
				loop: true,
				slidesPerView: 1,
				pagination: '.swiper-pagination',
				paginationClickable: true,
				autoplay: 3000,
			})
		},
		//banner跳转
		goBannerDetail(item){
			if(item.bannerUrl){
				this.goUrl(item.bannerUrl,'outNew')
			}
		},

		//获取几个登录入口信息
		getLoginEnter(){
			this.$axios({
				url:`/jxedu/api/site/platformJump`,
			}).then(res=>{
				let list = res.data
				this.loginList = list
			})
		},

		//跳转新闻详情
		goNewsDetail(contentId,parentId){
			this.goUrl({name:'newsDetail',params:{ id:contentId }, query:{ parentId  }})
		},

		//跳转院校详情
		goCollegesDetail(item){
			this.goUrl({name:'collegesDetail',params:{ id:item.orgId }})
		},
	},

}
</script>

<style lang="less" scoped>
@import '~@/static/css/pc-course.less';
@import '~@/static/css/pc-collage.less';
.index-pc{ background:#F5F8FF;  }
.banner-mdl{
	width:100%; height:500px; position:relative; overflow: hidden; max-width:1920px;  margin:0 auto;
	.bg{ width:100%; height:100%; background-position:center top; background-size: auto 500px; background-repeat: no-repeat;
		&.hover{ cursor: pointer; }
	}
	img{ width:1920px; height: 500px; position:absolute; top:0; left:50%; margin-left:-960px;}
}
.index-head{
	display:flex; justify-content: center; margin-bottom:30px; align-items: flex-end;
	.title{
		h2{
			display:inline-block; font-size:30px; color:#131F33; font-weight: bold; line-height:45px; vertical-align: bottom;
			position:relative; padding-bottom:15px;
			&::after{
				content:''; display:inline-block; width: 68px; height: 4px; background: #2E75EB; border-radius: 2px;
				position:absolute; left:50%; bottom:0; margin-left:-34px;
			}
		}
		span{ font-size:16px; color:#BCC3CD; line-height:16px; vertical-align: bottom; margin-left:10px;  display:none;}
	}
	.more{
		display:inline-block; font-size:14px; line-height:14px; color:#1677FF; vertical-align: bottom; position:relative; padding-right:16px;
		&::after{
			content:''; display:inline-block; width:10px; height:10px; background:url('../../static/img/tri-blue.png') right center;
			position:absolute; right:0; top:50%; margin-top:-4px;  background-size: 10px 10px;
		}
		&:hover{ text-decoration: underline; }
	}
}

//登录入口
// .login-enter{
// 	margin-top:-30px; position:relative; z-index:10;
// 	.list{
// 		display:flex; align-items: center; overflow:hidden;
// 		height: 120px; background: #FFFFFF; box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.06); border-radius: 4px;
// 		border-radius: 4px; position:relative;
// 		li{
// 			flex:1; text-align:center;
// 			a{
// 				position:relative; font-size:16px; color:#333333; display:block; width:100%; text-align: center;
// 				transition:all .3s; padding:84px 0 20px;
// 				&::after{
// 					width:54px; height:54px; background-image:url(../../static/img/index/log-ico1.png); background-size:100% 100%;
// 					content:''; position:absolute; left:50%; top:20px; margin-left:-27px;
// 				}
// 				&:hover{ color:#1B86FF; background:#F2F8FF;}
// 				&:hover::after{
// 					background-image:url(../../static/img/index/log-ico1-act.png);
// 				}
// 			}
// 			&.ico2 a::after{ background-image:url(../../static/img/index/log-ico2.png); }
// 			&.ico2 a:hover::after{ background-image:url(../../static/img/index/log-ico2-act.png); }
// 			&.ico3 a::after{ background-image:url(../../static/img/index/log-ico3.png); }
// 			&.ico3 a:hover::after{ background-image:url(../../static/img/index/log-ico3-act.png); }
// 			&.ico4 a::after{ background-image:url(../../static/img/index/log-ico4.png); }
// 			&.ico4 a:hover::after{ background-image:url(../../static/img/index/log-ico4-act.png); }
// 		}
// 	}
// }

.mdl01{
	padding:40px 0; background:#ffffff;
	.mdl01-ctn{
		display:flex;
		.mdl01-left{
			flex:1; display: flex;
			.left-img{
				width:400px; height:240px; margin-right:36px;
				img{ width:100%; height:100%; background:#eee;}
			}

			.news-box{
				flex:1;
				.mdl01-tag{
					height:46px; padding-top:10px;  border-bottom:1px solid #D8DADD;  position:relative; margin-bottom:40px;
					span{
						float:left; padding:0 10px; height:46px; display:inline-flex; align-items: center; justify-content: center;
						font-size:20px; color:#666666; line-height:44px; position:relative; cursor: pointer; margin-right:36px;
						&.act{
							color:#2E75EB; font-weight: bold;
							&::after{
								content:''; width:100%; height:2px; background:#2E75EB;
								position:absolute; left:0; bottom:-1px;
							}
						}
					}
					.more{
						display:inline-block; font-size:14px; line-height:14px; color:#666666; vertical-align: bottom; padding-right:16px;
						position:absolute; right:0; top:50%; margin-top:-7px;
						&::after{
							content:''; display:inline-block; width:10px; height:10px;
							background:url('../../static/img/ico-tri.png') right center;
							position:absolute; right:0; top:50%; margin-top:-4px;  background-size: 10px 10px;
						}
					}
				}
				.news-list{
					 flex:1; background:#FFFFFF;
					 ul{
						 li{
							  display:flex; cursor: pointer; margin-bottom:14px;  justify-content: space-between;
							  position:relative; padding-left:24px;
							  &::before{
								  content:''; display:inline-block; width:6px; height:6px; background:#D8DADD;
								  position:absolute; left:0; top:50%; margin-top:-3px; border-radius:100%;
							  }
							 .date{ line-height: 14px;  color:#A3A8AF; margin-left:20px; }
							 h4{ flex:1; font-size:14px; color:#333333; line-height:20px; font-weight: bold;}
							 &:hover{
								h4{ color:#2E75EB; }
							 }
						 }
					 }
				}
			}
		}
		.mdl01-right{
			width:230px; margin-left:40px; box-sizing: border-box;

			.login-btns{
				display:flex; justify-content: space-between; flex-wrap:wrap; margin-bottom:-26px;
				li{
					margin-bottom:26px; height: 110px; width:110px;  padding-top:73px; text-align: center;
					box-sizing: border-box; border-radius: 4px; box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.05);
					font-size:14px; color:#333333;  position:relative; cursor: pointer;

					&::after{
						content:''; display:inline-block; width:64px; height:64px; position:absolute; top:9px; left:22px;
						background:url(../../static/img/index/log-ico1.png) no-repeat; background-size:100% 100%;
					}

					&.ico2::after{ background-image:url(../../static/img/index/log-ico2.png); }
					//&.ico2 a:hover::after{ background-image:url(../../static/img/index/log-ico2-act.png); }
					&.ico3::after{ background-image:url(../../static/img/index/log-ico3.png); }
					//&.ico3 a:hover::after{ background-image:url(../../static/img/index/log-ico3-act.png); }
					&.ico4::after{ background-image:url(../../static/img/index/log-ico4.png); }
					//&.ico4 a:hover::after{ background-image:url(../../static/img/index/log-ico4-act.png); }
				}
			}
		}
	}
}

.mdl02{
	padding:24px 0 40px; background:#F0F3FB;
	.mdl02-ctn{
		.more{
			width: 110px; height: 24px; line-height:24px; background: #FFFFFF;
			box-shadow: 0px 4px 8px 0px #E7EEFA; border-radius: 12px; margin:38px auto 0;
			font-size:14px; color:#B4B8BE; display:block; text-align: center;
		}
	}
}

.mdl03{
	padding:36px 0 48px;
	.mdl03-ctn{
		padding-top:10px;
		.more{
			width: 110px; height: 24px; line-height:24px; background: #FFFFFF;
			box-shadow: 0px 4px 8px 0px #E7EEFA; border-radius: 12px; margin:38px auto 0;
			font-size:14px; color:#B4B8BE; display:block; text-align: center;
		}
		.category-item{
			margin-bottom:20px;
			&:last-child{ margin-bottom:0; }
			h3{ font-size:18px; color:#666666; margin-bottom:24px; }

		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/index/tpl-pc.vue